const _ = require('lodash');
const chipId = 'uc-privacy-chip';

import { SettingsService } from '../../../services/settings-service';
const privacyChipTemplate = require('./templates/privacy-chip-template.hbs');

export default class PrivacyChipViewController {
	private privacyCenterModalViewController: any;
	private utilityService: any;

	private isVisible: boolean;

	get settingsService() {
		return this.utilityService.settingsService;
	}

	private chipElement: any;
	private updateView: any;
	private privacyCornerModalViewController: any;

	constructor(
		updateView,
		utilityService,
		privacyCornerModalViewController,
		privacyCenterModalViewController
	) {
		this.updateView = updateView;

		this.privacyCenterModalViewController = privacyCenterModalViewController;
		this.privacyCornerModalViewController = privacyCornerModalViewController;
		this.utilityService = utilityService;
	}

	private getHtml() {
		return privacyChipTemplate({
			settings: this.settingsService.settings,
			location: this.settingsService.settings.chipDisplayLocation
				? this.settingsService.settings.chipDisplayLocation.trim()
				: 'bl'
		});
	}

	private getPreparedLayoutParams() {
		const layouts = SettingsService.layouts;
		const goalLayout = _.find(layouts, {
			name: this.settingsService.settings.layout
		});

		return {
			view: goalLayout.chipView,
			settings: this.settingsService.settings
			//todo
		};
	}

	public initHandling() {
		const self = this;

		if (this.visible) {
			this.chipElement = document.getElementById(chipId);
			if (this.chipElement) {
				this.chipElement.onclick = () => {
					if (self.settingsService.settings.privacyModal === 1) {
						if (self.privacyCornerModalViewController.visible) {
							self.privacyCornerModalViewController.closeModal();
						} else {
							self.privacyCornerModalViewController.openModal();
						}
					} else {
						self.privacyCenterModalViewController.openModal();
						self.updateView();
					}
				};
			}
		}
	}

	public set visible(_isVisible: boolean) {
		this.isVisible = _isVisible;
	}

	public get visible() {
		return this.settingsService.elementsVisibility.chipButton;
	}

	public get htmlString(): string {
		if (this.visible) {
			return this.getHtml();
		}
		return '';
	}
}
